import { render, staticRenderFns } from "./RetailOrder.vue?vue&type=template&id=32f9963f"
import script from "./RetailOrder.vue?vue&type=script&lang=js"
export * from "./RetailOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports